module.exports = "/images/pest-infestation@3x.png?f4ffbf664715b543db40df9cba88cbe5";